import { TransactionItemTypeEnum } from "@repo/core/constants/transactions";

export const operationName: { [key: string]: string } = {
  [TransactionItemTypeEnum.COMPRA]: "Compra",
  [TransactionItemTypeEnum.SAQUE]: "Saque",
  [TransactionItemTypeEnum.PONTUACAO]: "Pontuação",
  [TransactionItemTypeEnum.PAGAMENTO]: "Pagamento"
};

export const operationColor: { [key: string]: string } = {
  [TransactionItemTypeEnum.COMPRA]: "$secondary500",
  [TransactionItemTypeEnum.SAQUE]: "$secondary500",
  [TransactionItemTypeEnum.PONTUACAO]: "$secondary500",
  [TransactionItemTypeEnum.PAGAMENTO]: "$secondary500"
};
